// Navbar component with inline SVG logo and brand text
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiLogOut, FiBarChart2, FiSettings, FiGrid, FiFolder } from "react-icons/fi";
import { LOGO_BASE64, BRAND_TEXT_BASE64 } from "../utils/brandAssets";
import "../styles/Navbar.css";

export default function Navbar({ user, onLogout }) {
  const location = useLocation();
  const isBio = location.pathname.startsWith("/bio");
  const isAnalytics = location.pathname.startsWith("/analytics");
  const isAdvanced = location.pathname.startsWith("/advanced");
  const isCampaigns = location.pathname.startsWith("/campaigns");
  const isDashboard = !isBio && !isAnalytics && !isAdvanced && !isCampaigns;

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <Link to="/" className="navbar-brand" draggable="false">
          <img src={LOGO_BASE64} alt="" className="brand-logo" draggable="false" />
          <img src={BRAND_TEXT_BASE64} alt="" className="brand-text" draggable="false" />
        </Link>
        <div className="navbar-nav">
          <Link to="/" className={`navbar-nav-link${isDashboard ? " active" : ""}`}>
            Dashboard
          </Link>
          <Link to="/campaigns" className={`navbar-nav-link${isCampaigns ? " active" : ""}`}>
            <FiFolder size={13} /> Campaigns
          </Link>
          <Link to="/bio" className={`navbar-nav-link${isBio ? " active" : ""}`}>
            <FiGrid size={13} /> Bio Pages
          </Link>
          <Link to="/analytics" className={`navbar-nav-link${isAnalytics ? " active" : ""}`}>
            <FiBarChart2 size={13} /> Analytics
          </Link>
          <Link to="/advanced" className={`navbar-nav-link${isAdvanced ? " active" : ""}`}>
            <FiSettings size={13} /> Advanced
          </Link>
        </div>
      </div>
      <div className="navbar-right">
        <span className="navbar-user">{user.name || user.email}</span>
        <button className="navbar-logout" onClick={onLogout} data-tooltip="Sign out">
          <FiLogOut />
        </button>
      </div>
    </nav>
  );
}
